import React from 'react'
import { AuthToken, AuthUser } from './typings/auth.def'
import AppCore from './pages/core/AppCore'
import { LinearProgress } from '@material-ui/core'
import useFetch, { FetchResult } from 'react-fetch-hook'
import CONFIG from './config'
import { RouteState } from './typings/router.def'
import globalhistory from './router/globalhistory'
import { setApolloAuth, unsetApolloAuth } from './apollo/apollo-client'
import { WEBHOOK_API_PATHS } from './utils/fetchApi'
import AuthProvider from './components/layout/AuthProvider'

export default function App() {
  let refetchToken: string | null = localStorage.getItem(AuthToken.Refetch)
  if (typeof refetchToken === 'string' && refetchToken === 'undefined') {
    refetchToken = null
    localStorage.removeItem(AuthToken.Refetch)
  }

  const { isLoading, data, error }: FetchResult<AuthUser> = useFetch(
    `${CONFIG.REACT_APP_WEBHOOK_SERVER}${WEBHOOK_API_PATHS.verifyAuth}?resume_token=${refetchToken}`,
    {
      depends: [!!refetchToken]
    }
  )
  // call setApolloAuth directly due to useFetch data is already a hook. Don't wrap into effect
  if (error || (data && typeof data === 'object' && data.error)) {
    console.error(error || data)
    unsetApolloAuth()
    // we use globalhistory instead of hook to prevent re-rendering
    globalhistory.push(RouteState.Login)
  }
  if (data) {
    setApolloAuth(data)
  }

  return isLoading ? (
    <LinearProgress variant={'query'} color={'primary'} />
  ) : (
    <AuthProvider data={data}>
      <AppCore />
    </AuthProvider>
  )
}
